
















































































































































































































































































import { Vue, Component, Prop } from "vue-property-decorator";
import  { StudentAssignmentTirEstivoInfo } from "../../_models/studentAssignmentTirEstivo"

@Component
export default class DeataisTirEstivo extends Vue {
  @Prop() info!: StudentAssignmentTirEstivoInfo;

}
